import { Dialog } from '@loadsmart/miranda-react'

import { Content, Message } from './BidDialog.styles'
import { BidHeader } from './BidHeader'

export function BidDialogMessage({ header, Icon, children, onClose }) {
  return (
    <>
      <Dialog.Header>
        <BidHeader title={header} onClose={onClose} />
      </Dialog.Header>
      <Dialog.Body>
        <Content>
          <Message>
            {Icon}
            {children}
          </Message>
        </Content>
      </Dialog.Body>
    </>
  )
}
